import { Box, Typography, } from "@mui/material";
import ContactForm from "components/Contact/ContactForm";
import PropTypes from "prop-types";
import React from "react";
import Unit from "./Unit.model";

function SignUpForm({ unit }) {
  return (
    <Box id="unit_page_contact_form" sx={{ pt: 7, pb: 5, px: { md: 4, xs: 2.5 }, }} >
      <Box sx={{ maxWidth: 525, mx: "auto", }} >
        {/* <ContactForm grid unit={unit}>
          <Box sx={{ maxWidth: 320, mb: 4, }} >
            <Typography variant="h3" sx={{ fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.25, mb: 3, }} >
              PREMIERE ÅBENT HUS
            </Typography>
            <Box sx={{ fontWeight: 700, lineHeight: 1.4, }} >
              Udfyld formularen og modtag en invitation til
              Premiere Åbent Hus
            </Box>
          </Box>
        </ContactForm> */}
      </Box>
    </Box>
  );
}

SignUpForm.propTypes = {
  unit: PropTypes.instanceOf(Unit).isRequired,
};



export default SignUpForm;
